import { add, eachMinuteOfInterval, format, startOfDay } from 'date-fns';
export const getTimeOptions = () => {
    const timeIntervals = eachMinuteOfInterval({
        start: new Date(2025, 0, 1, 0),
        end: new Date(2025, 0, 1, 23, 59, 59),
    }, { step: 20 });
    const options = timeIntervals.map((interval) => {
        const formattedTime = format(interval, 'hh:mm a');
        return {
            id: formattedTime,
            text: formattedTime.replace(/^0/, ''),
        };
    });
    return { timeIntervals, options };
};
export const getInitialTimeFromDate = (date) => {
    const { options, timeIntervals } = getTimeOptions();
    const dateMinutes = date.getHours() * 60 + date.getMinutes();
    let closestIndex = 0;
    let closestDiff = Infinity;
    for (let i = 0; i < timeIntervals.length; i++) {
        const intervalMinutes = timeIntervals[i].getHours() * 60 + timeIntervals[i].getMinutes();
        const diff = Math.abs(dateMinutes - intervalMinutes);
        if (diff < closestDiff) {
            closestDiff = diff;
            closestIndex = i;
        }
    }
    return options[closestIndex].id;
};
export const combineDateAndTime = (date, time) => {
    const { options, timeIntervals } = getTimeOptions();
    const selectedIndex = options.findIndex(({ id }) => id === time);
    const selectedInterval = timeIntervals[selectedIndex];
    return add(startOfDay(date), {
        hours: selectedInterval.getHours(),
        minutes: selectedInterval.getMinutes(),
    });
};
